"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str, params) {
  if (!params) return str;
  return String(str).replace(/\{([^}]+)\}/g, function (match, key) {
    if (params.hasOwnProperty(key)) {
      return String(params[key]);
    }
    return match;
  });
};


